enum ChartType {
	NineBox = "9-Box Chart",
	BarChart = "Bar Chart",
	ColumnChart = "Column Chart",
	ScatterChart = "Scatter Chart",
	HistogramChart = "Histogram Chart",
	TrendlineChart = "Trendline Chart",
	PieChart = "Pie Chart",
	Table = "Table",
}

type ChartOptionKey = "column" | "min" | "max" | "rangeOption" | string;

const nineBoxRequiredFields = new Set([
	"summary_review_subject",
	"summary_employee_manager",
	"summary_employee_group",
	"summary_survey_name", // Survey name for survey reports
	"summary_survey_participant", // Survey participant
]);

enum ReportAnalyticsRbacPermissions {
	CreateReport = "report_analytics:createReport",
	ViewReport = "report_analytics:viewReport",
	ViewReportSharedWithManagers = "report_analytics:viewReportSharedWithManagers",
	CreateEmployeeReport = "report_analytics:createEmployeeReport",
	ViewEmployeeReport = "report_analytics:viewEmployeeReport",
	ViewGoalReport = "report_analytics:viewGoalReportsList",
	ViewSurveyReport = "report_analytics:viewSurveyReport",
	ViewReportSharedWithContributors = "report_analytics:viewReportSharedWithContributors",
	ViewReportSharedWithGroupAdmins = "report_analytics:viewReportSharedWithGroupAdmins",
	ViewFilteredReport = "report_analytics:viewFilteredReport",
	CreateFilteredReport = "report_analytics:createFilteredReport",
}

export { ChartType, type ChartOptionKey, nineBoxRequiredFields, ReportAnalyticsRbacPermissions };
